import { c as _c } from "react/compiler-runtime";
import { CarouselDotsPropertiesType } from "@website/ui/carousel/carousel.types";
export const CarouselDots = t0 => {
  const $ = _c(8);
  const {
    currentSlide,
    dotsClassName,
    currentReference,
    keyCarousel,
    newDesign
  } = t0;
  const t1 = `${newDesign ? "" : "bg-on-color-disable"} z-1 absolute bottom-4 right-1/2 flex translate-x-1/2 ${dotsClassName} } gap-1 rounded-full px-2.5 py-1`;
  let t2;
  if ($[0] !== currentReference?.track?.details?.slides?.length || $[1] !== currentSlide || $[2] !== keyCarousel || $[3] !== newDesign) {
    t2 = [...Array.from({
      length: currentReference?.track?.details?.slides?.length
    }).keys()]?.map(index => <div className={`size-1.5 rounded-full ${currentSlide === index ? newDesign ? "bg-[#FFF]" : "bg-on-surface-secondary-high-emphasis" : newDesign ? "bg-[#DDD]" : "bg-on-surface-disable-info"}`} key={`${keyCarousel}-dot-${index}`} />);
    $[0] = currentReference?.track?.details?.slides?.length;
    $[1] = currentSlide;
    $[2] = keyCarousel;
    $[3] = newDesign;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};